var $6d042cae6243464b$exports = {};
$6d042cae6243464b$exports = {
  "alpha": "Alfa",
  "black": "zwart",
  "blue": "Blauw",
  "blue purple": "paarsblauw",
  "brightness": "Helderheid",
  "brown": "bruin",
  "brown yellow": "bruingeel",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "cyaan",
  "cyan blue": "cyaanblauw",
  "dark": "donker",
  "gray": "grijs",
  "grayish": "grijsachtig",
  "green": "Groen",
  "green cyan": "cyaangroen",
  "hue": "Kleurtoon",
  "light": "licht",
  "lightness": "Lichtsterkte",
  "magenta": "magenta",
  "magenta pink": "magentaroze",
  "orange": "oranje",
  "orange yellow": "oranjegeel",
  "pale": "bleek",
  "pink": "roze",
  "pink red": "rozerood",
  "purple": "paars",
  "purple magenta": "magentapaars",
  "red": "Rood",
  "red orange": "roodoranje",
  "saturation": "Verzadiging",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " transparant");
  },
  "very dark": "heel donker",
  "very light": "heel licht",
  "vibrant": "levendig",
  "white": "wit",
  "yellow": "geel",
  "yellow green": "geelgroen"
};
export { $6d042cae6243464b$exports as default };